import { render } from "./backgroundPresenter.vue?vue&type=template&id=585d808e&scoped=true"
import script from "./backgroundPresenter.vue?vue&type=script&lang=js"
export * from "./backgroundPresenter.vue?vue&type=script&lang=js"

import "./backgroundPresenter.vue?vue&type=style&index=0&id=585d808e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\clha\\Documents\\Development\\interflon-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585d808e"]])

export default __exports__